import type {
  FilterChatResponseUnion,
  FilterToolCallResultRequest,
  FilterUserMessageRequest,
} from '@brs/aw-frontend-ai-types';
import type { AxiosRequestConfig } from 'axios';
import { awFrontendAIApi } from './Base';
import { AW_FRONTEND_AI_FILTER_CHAT_PATH } from './Constants';

export function postFilterChatMessage(body: FilterUserMessageRequest, config?: AxiosRequestConfig) {
  const path = AW_FRONTEND_AI_FILTER_CHAT_PATH;
  return awFrontendAIApi.post<FilterChatResponseUnion>(path, body, config);
}

export function postFilterChatToolResult(body: FilterToolCallResultRequest, config?: AxiosRequestConfig) {
  const path = `${AW_FRONTEND_AI_FILTER_CHAT_PATH}/result`;
  return awFrontendAIApi.post<FilterChatResponseUnion>(path, body, config);
}
